import { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import outy from 'outy';

import { Checkbox } from 'components/Form';
import { Svg } from 'components/Svg';

import s from './s.module.css';

export const Columns = ({ options, buttonClassName, onChange, tabIndex }) => {
  const [show, setShow] = useState(false);
  const [buttonRef, setButtonRef] = useState(null);
  const [popperRef, setPopperRef] = useState(null);

  const { styles, attributes } = usePopper(buttonRef, popperRef, {
    placement: 'right-start',
    modifiers: [
      {
        name: 'offset',
        options: { offset: [0, 16] },
      },
      {
        name: 'preventOverflow',
        options: {
          padding: 8,
        },
      },
    ],
  });

  const closeHandler = () => {
    setShow(false);
  };

  const keyboardHandler = (event) => {
    if (event.key === 'Escape') {
      closeHandler();
    }
  };

  useEffect(() => {
    let outsideTap;
    if (show) {
      document.addEventListener('keydown', keyboardHandler, false);
      if (popperRef) {
        outsideTap = outy(
          [buttonRef, popperRef],
          ['click', 'touchend'],
          closeHandler
        );
      }
    }

    return () => {
      document.removeEventListener('keydown', keyboardHandler, false);
      if (outsideTap) {
        outsideTap.remove();
      }
    };
  }, [show, popperRef]);

  const handlerChange = (key) => {
    const newOptions = options.map((option) => {
      if (option.key === key) {
        return {
          ...option,
          selected: !option.selected,
        };
      }
      return option;
    });
    onChange(newOptions);
  };

  const handlerToggle = () => {
    setShow((prevState) => !prevState);
  };

  return (
    <>
      <button
        type="button"
        className={buttonClassName}
        ref={setButtonRef}
        onClick={handlerToggle}
        tabIndex={tabIndex}
      >
        <Svg id="filter" />
      </button>
      {show ? (
        <div
          ref={setPopperRef}
          style={styles.popper}
          {...attributes.popper}
          className={s.popper}
        >
          <div className={s.title}>
            <span>Select Columns</span>
            <button
              type="button"
              onClick={closeHandler}
              className={s.closeButton}
              tabIndex={0}
            >
              <Svg id="close" />
            </button>
          </div>
          {options.map(({ key, filterName, selected }) => (
            <Checkbox
              key={key}
              checked={selected}
              onChange={() => handlerChange(key)}
              tabIndex={0}
              className={s.checkbox}
            >
              {filterName}
            </Checkbox>
          ))}
        </div>
      ) : null}
    </>
  );
};
